import { View, Html } from "@react-three/drei"

export default function TopHeader() {

    return (

        <div className="top-header-container">
            <div className="top-header-container-left">
                <div className="logo">
                    <img className="logo-img" src="./img/logo.png" alt="Logo de Maestrom" />
                </div>
                <div className="catch-phrase">
                    {/* <p className="catch-phrase-title karrik blue f36">OFFREZ VOUS UNE EXPERIENCE WEB</p> */}
                    <p className="catch-phrase-text sansita f40">
                        Un site premium qui fait de votre image un avantage concurrentiel, crédible et fiable.
                    </p>
                </div>
            </div>
            <a
                onClick={() =>
                    window.gtag("event", "contact_click", {
                        button_id: "header_contact_button",
                    })
                }
                className="contact-btn"
                href="#form"
            >
                <p>DEMANDEZ UN DEVIS</p>
            </a>
            <a className="contact-btn-mobile" href="#form"
                onClick={() =>
                    window.gtag("event", "contact_click", {
                        button_id: "header_contact_button",
                    })
                } >
                <img src="./img/contact-icon.svg" alt="Icon de contact" />
            </a>
        </div>

    )
}